import Vue from 'vue';

Vue.component('tank-index', () =>
    import(/* webpackChunkName: 'tank-index' */ './tank-index.vue'),
);
